module.exports = "<h5>{{ 'tags' | translate }}</h5>\r\n<div class=\"btn btn-primary btn-sm\"\r\n     *ngFor=\"let tag of tagsList; let i = index\"\r\n     style=\"margin: 2px;\"\r\n     [ngClass]=\"{'btn-outline-primary' : tag['id'] == tagId}\"\r\n     (click)=\"getNewsByTagId(tag)\">\r\n  <span class=\"fa fa-close\" *ngIf=\"tag['id'] == tagId\"></span> {{ tag.name }}\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/components/news-tags-list/news-tags-list.component.html
// module id = ./src/app/modules/shared/components/news-tags-list/news-tags-list.component.html
// module chunks = main